export default {
  nav: {
    main: 'Ana Sayfa',
    ordersAndInvoices: 'Siparişler ve Faturalar',
    drafts: 'Taslaklar',
    automation: 'Otomasyon',
    workspace: 'Çalışma Alanı',
    templates: 'Şablonlar',
    delivery: 'Teslimat',
    settings: 'Ayarlar',
    shippingLabels: 'Kargo Etiketleri',
    subscriptions: 'Abonelikler',
    support: 'Destek',
    developer: 'Geliştirici',
    writeReview: 'Değerlendirme Yaz',
    supportTicket: 'Destek Talebi',
    welcomeTour: 'Hoş Geldiniz Turu',
    administratorConsole: 'Yönetici Konsolu',
    logout: 'Çıkış Yap',
  },
  dashboard: {
    pageTitle: 'Siparişler ve Faturalar',
    pageDescription: 'Manage your orders and invoices',
    title: 'Siparişler ve Faturalar',
    selectedOrders: '{count} seçili sipariş',
    completed: '% tamamlandı',
    processing: 'İşleniyor, lütfen bekleyin...',
    bulkDownload: 'Toplu İndirme',
    upgradeBulkDownload: 'Toplu İndirme için planınızı yükseltin',
    showFilters: 'Filtreleri Göster',
    hideFilters: 'Filtreleri Gizle',
    creatingInvoices: 'Faturalar oluşturuluyor, lütfen bekleyin...',
    bulkCreateInvoices: 'Toplu Fatura Oluştur',
    cannotCreateAutopilot: 'Faturalama modu otomatik pilottayken manuel fatura oluşturamazsınız.',
    exportInvoices: 'Faturaları veya siparişleri dışa aktar',
    capturePayments: 'Ödemeleri Manuel Olarak Al',
    filterOrders: 'Siparişleri filtrele',
    error: 'Bir şeyler ters gitti...',
    close: 'Kapat',
    chooseDate: 'Bir tarih seçin',
    chooseIssueDate: 'Seçili faturalar için bir düzenleme tarihi seçin',
    cancel: 'İptal',
    createInvoices: 'Fatura Oluştur',
    storno: 'Storno',
    bulkOrderCapture: 'Toplu Sipariş Alma',
  },
  search: {
    createdBetween: 'Oluşturulma tar.',
    modifiedBetween: 'Değiştirilme tar.',
    orderNumber: 'Sipariş #',
    invoiceNumber: 'Fatura #',
    refundNumber: 'İade #',
    customer: 'Müşteri',
    payment: 'Ödeme',
    any: 'Herhangi',
    authorized: 'Yetkilendirildi',
    pending: 'Beklemede',
    paid: 'Ödendi',
    partiallyPaid: 'Kısmen ödendi',
    refunded: 'İade edildi',
    voided: 'İptal edildi',
    partiallyRefunded: 'Kısmen iade edildi',
    unpaid: 'Ödenmedi',
    fulfillment: 'Karşılama',
    fulfilled: 'Gönderildi',
    partial: 'Kısmi',
    unfulfilled: 'Gönderilmedi',
    loading: 'Siparişler yükleniyor...',
    search: 'Ara',
  },
  orderList: {
    noCustomer: 'Müşteri Yok',
    downloadOrder: 'Siparişi İndir',
    deleteWarning: 'Önemli! Bu, şu tarihten sonra oluşturulan tüm faturaları ve iadeleri silecektir:',
    includingInvoice: 'seçilen fatura # dahil',
    pressOk: 'Devam etmek için Tamam veya iptal etmek için İptal düğmesine basın.',
    cannotCreateAutopilot: 'Faturalama modu otomatik pilottayken manuel fatura oluşturamazsınız.',
    createInvoice: 'Bu sipariş için fatura oluştur',
    create: 'Oluştur',
    addCreditNote: 'Alacak Dekontu Ekle',
    createStorno: 'Storno Fatura Oluştur',
    refund: 'İade',
    downloadInvoice: 'Bu faturayı indir',
    download: 'İndir',
    default: 'Varsayılan',
    downloadStorno: 'Bu storno/alacak dekontunu indir',
    fulfillOrder: 'Siparişi Karşıla',
    orderNum: 'Sipariş #',
    locPrefix: 'Konum Ön Eki',
    invoiceNum: 'Fatura #',
    refundNum: 'İade #',
    customerCol: 'Müşteri',
    orderCreatedDate: 'Sipariş Oluşturulma Tarihi',
    orderModifiedDate: 'Sipariş Değiştirilme Tarihi',
    delivered: 'Teslim Edildi',
    paymentStatus: 'Ödeme Durumu',
    fulfillmentStatus: 'Gönderim durumu',
    totalOutstanding: 'Toplam Ödenmemiş Tutar',
    originalPrice: 'Orijinal Fiyat',
    noOrders: 'Mağazanızda seçili durum için sipariş bulunmamaktadır.',
    cannotCreateNoOrders: 'Sipariş olmadığında fatura oluşturamazsınız.',
    createOrdersFirst: 'Lütfen en az bir sipariş oluşturun ve tekrar deneyin.',
    createOrders: 'Sipariş oluştur',
    loadingOrders: 'Yükleniyor...',
    paidManual: 'Ödendi - Manuel',
    paid: 'Ödendi',
    refunded: 'İade edildi',
    pending: 'Beklemede',
    partiallyPaid: 'Kısmen ödendi',
    partiallyRefunded: 'Kısmen iade edildi',
    fulfilled: 'Gönderildi',
    unfulfilled: 'Gönderilmedi',
    deliveryPending: 'Beklemede',
    deliverNow: 'Şimdi teslim et',
    deliveryPartial: 'Kısmi',
    notDelivered: 'Teslim edilmedi',
    deliverAgain: 'Tekrar teslim et',
    deliveryDetails: 'Teslimat detayları',
    deliveryFailed: 'Teslimat başarısız',
    sent: 'Gönderildi',
    failed: 'Başarısız',
    toLabel: 'Kime',
    folderLabel: 'Klasör',
    open: 'Açık',
    invoice: 'Fatura',
    creditNote: 'Alacak dekontu',
    stornoLabel: 'Storno',
    unknown: 'Bilinmiyor',
    googleDrive: 'Google Drive',
    clientsTablet: 'Müşteri tableti',
    shippyPro: 'ShippyPro',
    emailChannel: 'E-posta',
    ftpChannel: 'FTP',
    revertToDate: 'Bu tarihe geri dön',
    add: 'Ekle',
    close: 'Kapat',
  },
  downloadDialog: {
    downloadType: '{type} İndir...',
    selectTemplate: 'Siparişleri, faturaları, storno faturaları veya alacak dekontlarını dışa aktarmak için galeriden bir şablon seçin.',
    getMoreTemplates: 'Daha Fazla Şablon Alın',
    createNewTemplate: 'Yeni Şablon Oluştur',
    allCreatedBetween: 'Arasında oluşturulan tüm {type}',
    selectedType: 'Seçili {type}',
    and: 've',
    status: 'Durum',
    any: 'Herhangi',
    open: 'Açık',
    closed: 'Kapalı',
    cancelled: 'İptal Edildi',
    paymentStatus: 'Ödeme Durumu',
    fulfillmentStatus: 'Gönderim durumu',
    fulfilled: 'Gönderildi',
    partial: 'Kısmi',
    unfulfilled: 'Gönderilmedi',
    authorized: 'Yetkilendirildi',
    pending: 'Beklemede',
    paid: 'Ödendi',
    partiallyPaid: 'Kısmen ödendi',
    refunded: 'İade edildi',
    voided: 'İptal edildi',
    partiallyRefunded: 'Kısmen iade edildi',
    unpaid: 'Ödenmedi',
    format: 'Format',
    forLocation: 'Konum',
    advancedOptions: 'Gelişmiş seçenekler',
    exportHSCodes: 'Envanter HS kodlarını dışa aktar (daha yavaş)',
    noteChrome: 'Not: Optimum indirme için Chrome tarayıcı önerilir ve reklam engelleyicinin devre dışı bırakılması gerekir.',
    downloadIndividually: 'Tek tek indir',
    downloadGrouped: 'Gruplu indir',
  },
  templates: {
    pageTitle: 'Şablonlar',
    pageDescription: 'Customize your invoice templates',
    title: 'Şablonlar',
    installTranslated: 'Çevrilmiş bir şablon yükleyin',
    installTranslatedDesc: 'Bu düğmeye tıklayarak farklı bir dil seçin.',
    createNew: 'Gerekirse yeni bir şablon oluşturun',
    createNewDesc: 'Gerekirse yeni bir şablon oluşturmak için bu düğmeye tıklayın.',
    customize: 'Şablonları özelleştir',
    customizeDesc: 'Özelleştirmek için varsayılan şablona tıklayın. Logo, renkleri ve ileri düzey kullanıcılar için arkadaki kodu değiştirebilirsiniz.',
    defaultTemplate: 'Fatura, Storno ve Alacak Dekontu (Varsayılan)',
    logo: 'Logo',
    colorPalette: 'Renk Paleti',
    getColorPalettes: 'Renk paletleri alın',
    paperSize: 'Kağıt Boyutu',
    format: 'Format',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Roll (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Roll (57.5 x 155 mm)',
    orientation: 'Yön',
    landscape: 'Yatay',
    portrait: 'Dikey',
    margin: 'Kenar Boşluğu (cm)',
    unsavedChanges: 'Kaydedilmemiş değişiklikler',
    discard: 'Vazgeç',
    save: 'Kaydet',
  },
  labels: {
    pageTitle: 'Kargo Etiketleri',
    pageDescription: 'Create and manage shipping labels',
    title: 'Kargo Etiketleri',
    glsRequiresPro: 'Doğu Avrupa için GLS Kargo Etiketleri Profesyonel plan gerektirir.',
    upgradeDesc: 'Kargo etiketleri oluşturmak ve yönetmek için Profesyonel plana yükseltin.',
    upgradePlan: 'Planınızı yükseltin',
    eeuGls: 'EEU GLS',
    enabled: 'Etkin',
    country: 'Ülke',
    hungary: 'Macaristan',
    slovakia: 'Slovakya',
    czech: 'Çekya',
    romania: 'Romanya',
    slovenia: 'Slovenya',
    croatia: 'Hırvatistan',
    senderId: 'Gönderici Kimliği',
    username: 'Kullanıcı Adı',
    password: 'Şifre',
    name: 'Ad',
    city: 'Şehir',
    address: 'Adres',
    zipCode: 'Posta Kodu',
    contactPerson: 'İletişim Kişisi',
    phone: 'Telefon',
    email: 'E-posta',
    glsServices: 'GLS Hizmetleri',
    expressService: 'Ekspres Hizmet',
    exchangeService: 'Değişim Hizmeti',
    smsService: 'SMS Hizmeti',
    smsText: 'SMS Metni',
    preAdviceService: 'Ön Bildirim Hizmeti',
    unsavedChanges: 'Kaydedilmemiş değişiklikler',
    discard: 'Vazgeç',
    save: 'Kaydet',
  },
  billing: {
    pageTitle: 'Faturalandırma',
    pageDescription: 'Manage your subscription and billing',
    title: 'Faturalandırma',
    subscriptionFor: 'Mağaza için abonelik planı',
    currentlySubscribed: 'Şu anda abone olduğunuz plan',
    plan: 'plan',
    cancelSubscription: 'Aboneliği İptal Et',
    upgradePlan: 'Planınızı yükseltin',
    professional: 'Profesyonel',
    proPriceMonthly: '$29.99 / ay',
    upgrade: 'Yükselt',
    includesAllStarter: 'Tüm Başlangıç özelliklerini içerir, artı:',
    proFeature1: 'Küresel Uyumluluk Paketi: Konum bazlı ön ekler ve özel sıralı numaralandırma',
    proFeature2: 'Akıllı Yerelleştirme: Otomatik çevrilmiş e-postalar ve yerelleştirilmiş PDF ekleri',
    proFeature3: 'Eksiksiz B2B Belge Yaşam Döngüsü: Proformalar, B2B Teklifler ve Alacak Dekontları',
    proFeature4: 'B2B Muhasebe Senkronizasyonu: 3 ondalıklı birim hassasiyeti ve çoklu para birimi gösterimleri',
    proFeature5: 'Otomatik Yedekleme: Faturaları otomatik olarak güvenli FTP veya Google Drive\'a kopyalayın',
    proFeature6: 'Shopify Flow: Flow tetikleyicileri ve eylemleri ile fatura oluşturma, teslimat ve storno otomasyonu',
    proFeature7: 'Gelişmiş AI Mantığı: Karmaşık koşullu düzen maddeleri için cihaz üzerinde AI kullanın',
    proFeature8: 'UBL XML & ZUGFeRD / Factur-X dışa aktarımları (Avrupa E-fatura uyumluluğu)',
    proFeature9: 'Anlık mobil POS ödemeleri için EPC QR kodları',
    proFeature10: 'Doğu Avrupa için GLS Kargo Etiketleri',
    proFeature11: '7 yıl uyumluluk vergi saklama',
    currentlyUsing: 'Şu anda kullandığınız plan',
    free: 'ücretsiz',
    subscriptionPlan: 'abonelik planı.',
    monthlyUsage: 'Aylık Kullanım',
    monthlyGenerated: '{count} / 50 fatura bu ay',
    monthlyLimitReached: 'Aylık limit doldu. Sınırsız fatura için Başlangıç planına yükseltin.',
    freePlan: 'Ücretsiz Plan',
    freeToInstall: 'Ücretsiz kurulum',
    freeFeature1: 'Ayda 50 faturaya/siparişe kadar',
    freeFeature2: '31+ önceden tanımlanmış şablona erişim',
    freeFeature3: 'Temel AI Yardımcı',
    freeFeature4: 'Standart PDF indirme ve yazdırma',
    freeFeature5: 'Standart belge paketi (Faturalar, Sevk İrsaliyeleri, Makbuzlar)',
    freeFeature6: '3 aylık güvenli fatura saklama',
    starterPlan: 'Başlangıç Planı',
    starterPrice: '$9.99 / ay',
    starterPricePerInvoice: '+ oluşturulan fatura başına 3¢',
    subscribe: 'Abone Ol',
    starterFeature1: 'Sınırsız fatura ve sipariş',
    starterFeature2: 'E-posta ile otomatik PDF teslimatı',
    starterFeature3: 'Hibrit düzenleyici ve AI Yardımcıya tam erişim',
    starterFeature4: 'Shopify POS ve barkod entegrasyonu',
    starterFeature5: 'Shopify Flow: Fatura otomasyonu için tetikleyiciler ve eylemler',
    starterFeature6: 'UBL XML / PEPPOL & ZUGFeRD / Factur-X dışa aktarımları (E-fatura uyumluluğu)',
    starterFeature7: '1 yıl güvenli fatura saklama',
    proTaxOverrides: 'Özel Vergi Geçersiz Kılmaları: Ürün başına KDV / GST ve SKU düzeyinde oranlar',
    unsavedChanges: 'Kaydedilmemiş değişiklikler',
    discard: 'Vazgeç',
    save: 'Kaydet',
  },
  autopilot: {
    pageTitle: 'Otomasyon',
    pageDescription: 'Automate invoice creation and management',
    title: 'Otomasyon',
    autoCreate: 'Faturaları Otomatik Oluştur',
    disabled: 'Devre Dışı (Manuel)',
    whenCreated: 'Siparişler oluşturulduğunda',
    whenFulfilled: 'Siparişler karşılandığında',
    whenPaid: 'Siparişler ödendiğinde',
    autoCreateDesc: 'Faturalar, siparişlerin oluşturulduğu, karşılandığı veya ödendiği tarihte oluşturulacaktır.',
    autoStorno: 'Faturaları Otomatik Storno Et',
    whenCancelled: 'Siparişler iptal edildiğinde veya iade edildiğinde',
    autoStornoDesc: 'Storno faturaları, siparişlerin iptal edildiği veya iadelerin oluşturulduğu tarihte oluşturulacaktır.',
    cannotAutoFree: 'Ücretsiz plan ile otomatik fatura oluşturma yapılamaz.',
    upgradePlan: 'Planınızı yükseltin',
    unsavedChanges: 'Kaydedilmemiş değişiklikler',
    discard: 'Vazgeç',
    save: 'Kaydet',
  },
  delivery: {
    pageTitle: 'Teslimat',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: 'Teslimat',
    settings: 'Ayarlar',
    useOrderNumbers: 'Dosyalar için sipariş numaralarını kullan',
    sendIfCountry: 'Fatura adresi ülkesi şu ise gönder',
    countryCodesHint: 'Tüm ülke kodlarını noktalı virgülle ayırarak listeleyin.',
    sendForTags: 'Listelenen etiketlerden birine sahip müşteriler için gönder',
    tagsHint: 'Tüm etiketleri noktalı virgülle ayırarak listeleyin.',
    emailDelivery: 'E-posta Teslimatı',
    sendAsPdf: 'Faturaları müşterilere PDF eki olarak gönder',
    autoSend: 'Fatura oluşturulduğunda otomatik gönder',
    subject: 'Konu',
    body: 'Gövde',
    xmlAttachments: 'XML Ekleri',
    attachUbl: 'UBL/PEPPOL XML (E-Factura) ekle',
    attachZugferd: 'ZUGFeRD / Factur-X XML ekle',
    sendTestEmail: 'Test E-postası Gönder',
    sending: 'Gönderiliyor...',
    customSmtp: 'Özel SMTP Sunucusu',
    customSmtpDesc: 'Varsayılan yerine kendi posta sunucunuzu kullanın',
    enableSmtp: 'Özel SMTP etkinleştir',
    smtpHost: 'SMTP Sunucusu',
    port: 'Port',
    useSsl: 'SSL/TLS Kullan',
    username: 'Kullanıcı Adı',
    password: 'Şifre',
    fromEmail: 'Gönderen E-posta',
    fromName: 'Gönderen Adı',
    shopifyLiquid: 'Shopify Liquid Şablonu',
    pasteInto: 'Bunu şuraya yapıştırın',
    orderConfirmation: 'sipariş onay şablonu',
    toAddLink: 'indirme bağlantısı eklemek için.',
    downloadInvoice: 'Faturanızı indirin',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: 'Faturalar oluşturulduğunda ClientsTablet\'e istek gönder',
    shippyPro: 'ShippyPro',
    shippyProDesc: 'AB dışı ülkeler için PDF faturaları gümrük belgesi olarak ShippyPro\'ya gönder',
    ftpBackup: 'FTP / SFTP Yedekleme',
    ftpDesc: 'Faturaları otomatik olarak sunucunuza kopyalayın',
    enableFtp: 'Otomatik FTP yedeklemeyi etkinleştir',
    host: 'Sunucu',
    useSftp: 'SFTP kullan (güvenli)',
    destinationFolder: 'Hedef klasör',
    xmlFiles: 'XML Dosyaları',
    includeUbl: 'UBL/PEPPOL XML (E-Factura) dahil et',
    includeZugferd: 'ZUGFeRD / Factur-X XML dahil et',
    testConnection: 'Bağlantıyı Test Et',
    testing: 'Test ediliyor...',
    pro: 'PRO',
    upgradeFtp: 'Faturaları otomatik olarak FTP/SFTP sunucunuza kopyalamak için Profesyonel plana yükseltin.',
    googleDrive: 'Google Drive',
    googleDriveDesc: 'Faturaları otomatik olarak Drive\'ınıza senkronize edin',
    connected: 'Bağlı',
    disconnect: 'Bağlantıyı Kes',
    notWorking: 'Çalışmıyor mu? Şuraya gidin',
    googlePermissions: 'Google İzinleri',
    removeThenReconnect: 'Invoice Browse\'u kaldırın, ardından yeniden bağlayın.',
    connectGoogleDrive: 'Google Drive Bağla',
    upgradeGoogleDrive: 'Faturaları otomatik olarak Google Drive\'a senkronize etmek için Profesyonel plana yükseltin.',
    unsavedChanges: 'Kaydedilmemiş değişiklikler',
    discard: 'Vazgeç',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: 'Kaydet',
  },
  bookkeeping: {
    pageTitle: 'Ayarlar',
    pageDescription: 'Configure your invoice settings',
    title: 'Ayarlar',
    owner: 'Sahip',
    email: 'E-posta',
    phone: 'Telefon',
    keepDifferentNumbering: 'Her sipariş konumu için farklı fatura numaralandırması tut',
    keepDifferentNumberingDisabled: 'Her sipariş konumu için farklı fatura numaralandırması tutma seçeneği planınızda etkin değildir.',
    locationEmailDesc: 'Bu, sipariş konumuna göre çevrilmiş e-postalar ve faturalar göndermenizi sağlar: envanter konumu, teslimat veya fatura adresi',
    upgradePlan: 'Planınızı yükseltin',
    matchingCriteria: 'Eşleştirme Kriterleri',
    locationId: 'Konum Kimliği',
    shippingCountryCode: 'Teslimat Adresi Ülke Kodu',
    billingCountryCode: 'Fatura Adresi Ülke Kodu',
    matchLocationDesc: 'Sipariş konum kimliği, teslimat veya fatura adresi ülke koduna göre konum eşleştirin.',
    companyInfo: 'Şirket Bilgileri',
    name: 'Ad',
    website: 'Web Sitesi',
    registrationNumber: 'Sicil Numarası',
    taxId: 'Vergi Kimlik No',
    addressSection: 'Adres',
    streetName: 'Sokak Adı',
    streetNumber: 'Sokak Numarası',
    zip: 'Posta Kodu',
    city: 'Şehir',
    region: 'Bölge',
    country: 'Ülke',
    bankingInfo: 'Banka Bilgileri',
    bankName: 'Banka Adı',
    swift: 'Swift',
    currency: 'Para Birimi',
    iban: 'IBAN',
    invoicing: 'Faturalama',
    decimalPlaces: 'Ondalık Basamaklar',
    invoicesPrefix: 'Fatura Ön Eki',
    currentInvoiceNumber: 'Mevcut Fatura Numarası',
    creditNotesPrefix: 'Alacak Dekontu Ön Eki',
    currentCreditNoteNumber: 'Mevcut Alacak Dekontu Numarası',
    lastInvoiceDate: 'Son Fatura Tarihi',
    noInvoicesYet: 'Henüz fatura oluşturulmadı.',
    confirmReverting: 'Geri Alma Sistemini Onayla',
    allInvoicesAfter: 'Şu tarihten sonra düzenlenen tüm faturalar ve stornoları',
    willBeRemoved: 'kaldırılacaktır. Sistemi geri almaya devam edilsin mi?',
    cancel: 'İptal',
    revert: 'Geri Al',
    revertDesc: 'Sistemi geri almak, seçilen tarihten sonra oluşturulan tüm faturaları silecektir.',
    revertToDate: 'Bu tarihe geri al',
    reverting: 'Sistem geri alınıyor, lütfen bekleyin...',
    useOrderNumbering: 'Sipariş numaralandırmasını kullan',
    showVat: 'Faturalarda KDV göster',
    overrideTaxes: 'Vergileri Geçersiz Kıl',
    pricesIncludeTax: 'Fiyatlar vergi dahildir',
    productsTaxRate: 'Ürün Vergi Oranı',
    shippingTaxRate: 'Kargo Vergi Oranı',
    skusSeparated: 'Noktalı virgülle ayrılmış SKU\'lar',
    skusTaxRate: 'SKU Vergi Oranı',
    useOrderDates: 'Faturalar için sipariş oluşturma tarihlerini kullan',
    convertCurrency: 'Fiyatları müşterinin ödeme yaptığı para birimine dönüştür',
    unsavedChanges: 'Kaydedilmemiş değişiklikler',
    discard: 'Vazgeç',
    save: 'Kaydet',
  },
  drafts: {
    pageTitle: 'Taslaklar',
    pageDescription: 'Manage your draft orders',
    title: 'Taslaklar',
    download: 'İndir',
    newDraft: 'Yeni Taslak',
    exporting: 'Dışa aktarılıyor {status}%...',
    accessNotGranted: 'Taslak Siparişler erişimi verilmedi. Lütfen',
    reLogin: 'yeniden giriş yapın',
    toGrantPermissions: 'gerekli "Taslak Siparişler" izinlerini vermek için.',
    pushFailed: 'Shopify\'a gönderim başarısız:',
    exportError: 'Dışa aktarma hatası:',
    confirmDelete: 'Bu taslağı silmek istediğinizden emin misiniz?',
    incompleteCustomer: 'Müşteri verileri eksik:',
    pushWithoutCustomer: 'Taslak, müşteri verileri olmadan Shopify\'a gönderilecektir. Devam edilsin mi?',
    customerNotInShopify: 'Bu müşteri henüz Shopify\'da mevcut değil.',
    warnings: 'Uyarılar:',
    createCustomerAndPush: 'Müşteri Shopify\'da oluşturulup taslak sipariş gönderilsin mi?',
  },
  draftEdit: {
    number: "Numara",
    prefix: "Önek",

    newDraft: 'Yeni Taslak',
    editDraft: 'Taslağı Düzenle',
    viewInShopify: 'Shopify\'da Görüntüle',
    back: 'Geri',
    createDraft: 'Taslak Oluştur',
    saveChanges: 'Değişiklikleri Kaydet',
    documentType: 'Belge Türü',
    draftOrder: 'Taslak Sipariş',
    quote: 'Teklif',
    proforma: 'Proforma',
    manualInvoice: 'Manuel Fatura',
    currency: 'Para Birimi',
    expiryDate: 'Son Geçerlilik Tarihi',
    status: 'Durum',
    draft: 'Taslak',
    sent: 'Gönderildi',
    accepted: 'Kabul Edildi',
    customer: 'Müşteri',
    firstName: 'Ad',
    lastName: 'Soyad',
    email: 'E-posta',
    phone: 'Telefon',
    company: 'Şirket',
    taxId: 'Vergi Kimlik No',
    billingAddress: 'Fatura Adresi',
    address: 'Adres',
    aptSuite: 'Daire/Bölüm',
    city: 'Şehir',
    province: 'İl',
    countryField: 'Ülke',
    zip: 'Posta Kodu',
    shippingAddress: 'Teslimat Adresi',
    sameAsBilling: 'Fatura adresiyle aynı',
    lineItems: 'Kalemler',
    shipping: 'Kargo',
    shippingTitle: 'Başlık',
    shippingPlaceholder: 'örn. Standart Kargo',
    price: 'Fiyat',
    note: 'Not',
    notePlaceholder: 'Dahili not veya müşteriye mesaj...',
    summary: 'Özet',
    subtotal: 'Ara Toplam',
    discounts: 'İndirimler',
    tax: 'Vergi',
    total: 'Toplam',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'Mağaza adresinizi girin',
    loginWith: 'İle giriş yap',
    createAccount: 'Yeni hesap oluştur',
    placeholder: 'mağaza-adınız',
    shopRequired: 'Mağaza adı gereklidir',
    login: 'Giriş',
    shopify: 'Shopify',
    terms: 'Şartlar ve Koşullar',
    privacy: 'Gizlilik Politikası',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'Invoice Browse\'u beğeniyor musunuz?',
    description: "İlk faturalarınızı oluşturdunuz! Uygulamayı faydalı buluyorsanız, Shopify App Store'da hızlı bir değerlendirme bize çok yardımcı olur.",
    reward: "Teşekkür olarak, aylık kullanım sayacınızı 0'a sıfırlayacağız",
    leaveReview: 'Değerlendirme Bırak',
    maybeLater: 'Belki daha sonra',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'Invoice Browse\'a Hoş Geldiniz',
    welcomeContent: 'Nasıl kullanabileceğinizi göstereyim.',
    dashboardTitle: 'Kontrol Paneli',
    dashboardContent: 'Gördüğünüz ekran ana kontrol panelidir. Burada tüm siparişleri bulabilir ve bunları fatura, sevk irsaliyesi gibi farklı belge türlerine dışa aktarabilirsiniz.',
    automationTitle: 'Hayatınızı kolaylaştırın',
    automationContent: 'Siparişler ödendiğinde veya iade edildiğinde otomatik fatura oluşturmak için otomasyonu etkinleştirin.',
    templatesTitle: 'Şablonları özelleştir',
    templatesContent: 'Şablonunuzu çevirmek, özelleştirmek veya yeni bir tane oluşturmak için buraya girin.',
    deliveryTitle: 'Teslimat',
    deliveryContent: 'Oluşturulan belgeleri otomatik olarak FTP, Google Drive\'a veya e-posta eki olarak kopyalamak için uygulamamızı yapılandırın.',
    settingsTitle: 'Ayarlar',
    settingsContent1: 'Belgelerde kullanılan şirket telefon numarası, e-posta ve diğer alanları ayarlayın.',
    settingsContent2: 'Belge başlangıç numarasını değiştirin veya belirli bir tarihten sonra oluşturulan belgeleri silin.',
    settingsContent3: 'Kargo ve ürünler için KDV oranlarını geçersiz kılın',
    settingsContent4: 'Sayılar için ondalık basamakları değiştirin',
    reviewTitle: 'Değerlendirme yazın',
    reviewContent: 'Bize güzel bir değerlendirme yazarak ekibimizi destekleyin!',
    tourTitle: 'Hoş geldiniz turu',
    tourContent: 'Bu turu buradan tekrar açabilirsiniz.',
    createDocTitle: 'İlk belgenizi oluşturun',
    createDocContent: 'İlk belgenizi oluşturmak için Oluştur düğmesine tıklayın.',
    docNumberTitle: 'Belge numarası',
    docNumberContent: 'İlk belgeye 1 numarası atanmıştır. Başka bir numarayla başlamak isterseniz bunu Ayarlar\'dan değiştirebilirsiniz.',
    downloadDocTitle: 'Belgeyi indir',
    downloadDocContent: 'Siparişinizi PDF olarak dışa aktarmak için İndir açılır menüsüne tıklayın ve bir belge şablonu seçin.',
  },
  common: {
    save: 'Kaydet',
    cancel: 'İptal',
    close: 'Kapat',
    discard: 'Vazgeç',
    delete: 'Sil',
    edit: 'Düzenle',
    create: 'Oluştur',
    loading: 'Yükleniyor...',
    unsavedChanges: 'Kaydedilmemiş değişiklikler',
    upgradePlan: 'Planınızı yükseltin',
  },
  languageSelector: {
    label: 'Dil',
    auto: 'Otomatik algıla',
  },
  draftList: {
    draftNum: 'Taslak #',
    shopifyId: 'Shopify ID',
    type: 'Tür',
    customer: 'Müşteri',
    total: 'Toplam',
    status: 'Durum',
    delivered: 'Teslim edildi',
    date: 'Tarih',
    actions: 'İşlemler',
    noCustomer: 'Müşteri yok',
    noDrafts: 'Taslak veya teklif bulunamadı.',
    loading: 'Yükleniyor...',
    download: 'İndir',
    default: 'Varsayılan',
    pending: 'Beklemede',
    deliverNow: 'Şimdi teslim et',
    deliveryDetails: 'Teslimat detayları',
    sent: 'Gönderildi',
    failed: 'Başarısız',
    deliverAgain: 'Tekrar teslim et',
    partial: 'Kısmi',
    notDelivered: 'Teslim edilmedi',
    deliveryFailed: 'Teslimat başarısız',
    unknown: 'Bilinmiyor',
    edit: 'Düzenle',
    send: 'Gönder',
    pushToShopify: 'Shopify\'a gönder',
    complete: 'Tamamla',
    duplicate: 'Kopyala',
    delete: 'Sil',
    quote: 'Teklif',
    proforma: 'Proforma',
    draftOrder: 'Taslak sipariş',
    manualInvoice: 'Manuel fatura',
  },
  draftSearch: {
    createdBtw: 'Oluşturulma arası',
    draftNum: 'Draft #',
    shopifyId: 'Shopify ID',
    customer: 'Müşteri',
    status: 'Durum',
    type: 'Tür',
    delivery: 'Teslimat',
    any: 'Tümü',
    draft: 'Taslak',
    sent: 'Gönderildi',
    accepted: 'Kabul edildi',
    expired: 'Süresi doldu',
    converted: 'Dönüştürüldü',
    cancelled: 'İptal edildi',
    quote: 'Teklif',
    proforma: 'Proforma',
    draftOrder: 'Taslak sipariş',
    manualInvoice: 'Manuel fatura',
    delivered: 'Teslim edildi',
    notDelivered: 'Teslim edilmedi',
    pending: 'Beklemede',
    search: 'Ara',
  },
  draftDownload: {
    title: 'İndir Taslak #...',
    selectTemplate: 'Select a template from the gallery to export drafts, quotes, or proformas.',
    allDraftsBetween: 'All drafts between',
    selectedDrafts: 'Selected drafts',
    and: 'and',
    status: 'Durum',
    documentType: 'Tür',
    any: 'Tümü',
    draft: 'Taslak',
    sent: 'Gönderildi',
    accepted: 'Kabul edildi',
    expired: 'Süresi doldu',
    converted: 'Dönüştürüldü',
    cancelled: 'İptal edildi',
    quote: 'Teklif',
    proforma: 'Proforma',
    draftOrder: 'Taslak sipariş',
    manualInvoice: 'Manuel fatura',
    format: 'Format',
    noTemplates: 'No templates found',
    noTemplatesForType: 'No templates found for document type "{type}".',
    installTemplates: 'Install templates',
    toStartExporting: 'to start exporting.',
    noteChrome: 'Note: For optimal download Chrome browser is recommended and any Adblocker to be disabled.',
    cancel: 'Cancel',
    downloadIndividually: 'Download Individually',
    downloadGrouped: 'Download Grouped',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: 'Yeni şablon yükle',
    tabStyle: 'Stil',
    tabContent: 'İçerik',
    tabTranslations: 'Çeviriler',
    tabSettings: 'Ayarlar',
    tabCode: 'Kod',
    tabCopilot: 'AI Yardımcı',
    logo: 'Logo',
    colorPalette: 'Renk paleti',
    colorText: 'Text',
    colorBg: 'BG',
    colorBorder: 'Border',
    colorPrimary: 'Primary',
    colorAccent: 'Accent',
    font: 'Font',
    fontDefault: 'Default (DM Sans)',
    fontSize: 'Font Size',
    fontSizeDefault: 'Default (11.5px)',
    fontSizeCompact: 'Compact',
    fontSizeSmall: 'Small',
    fontSizeMediumSmall: 'Medium Small',
    fontSizeMedium: 'Medium',
    fontSizeMediumLarge: 'Medium Large',
    fontSizeLarge: 'Large',
    fontSizeExtraLarge: 'Extra Large',
    documentTitle: 'Document Title',
    documentTitlePlaceholder: 'e.g. Invoice, Tax Invoice, Factura...',
    noToggleSupport: 'This template does not support toggle controls. Switch to a gallery template for full customization.',
    sections: 'Sections',
    shippingAddress: 'Shipping address',
    bankPaymentDetails: 'Bank / payment details',
    paymentStatusBadge: 'Payment status badge',
    orderNotes: 'Order notes',
    trackingFulfillment: 'Tracking / fulfillment info',
    termsConditions: 'Terms & conditions',
    signatureLines: 'Signature lines',
    qrCode: 'QR code',
    lineItems: 'Line Items',
    taxColumns: 'Tax columns (VAT / GST)',
    productSku: 'Product SKU',
    productImages: 'Product images',
    discountBreakdown: 'Discount breakdown',
    itemWeight: 'Item weight',
    hsCode: 'HS code (customs)',
    mergeDiscounts: 'Merge discounts into product price',
    showOrderDiscountAsSummary: 'Show order discount as a summary line',
    totals: 'Totals',
    subtotalBeforeTax: 'Subtotal (before tax)',
    taxBreakdownByRate: 'Tax breakdown by rate',
    shippingCostSeparate: 'Shipping cost as separate line',
    dueDate: 'Due date',
    formatting: 'Formatting',
    dateFormat: 'Date format',
    decimalPlaces: 'Decimal places',
    paymentTerms: 'Payment terms',
    paymentTermsNone: 'None',
    thankYouMessage: 'Thank you message',
    thankYouPlaceholder: 'Thank you for your business!',
    countryMatchTitle: 'Use this template when shipping or billing address matches this country',
    addressType: 'Address Type',
    addressDisabled: 'Disabled',
    addressShipping: 'Shipping Address',
    addressBilling: 'Billing Address',
    country: 'Country',
    anyCountry: 'Any country',
    countryMatchDesc: 'When enabled, this template will be used automatically for orders where the selected address matches the chosen country.',
    languagePreset: 'Language Preset',
    selectLanguage: 'Select a language...',
    languagePresetDesc: 'Selecting a language fills in all labels below. You can then customize individual fields.',
    paperSize: 'Paper Size',
    format: 'Format',
    orientation: 'Orientation',
    portrait: 'Portrait',
    landscape: 'Landscape',
    margin: 'Margin (cm)',
    template: 'Template',
    templateName: 'Name',
    systemAlias: 'System Alias',
    systemAliasDesc: 'for POS/Admin URL routes',
    systemAliasNone: 'None',
    defaultTemplate: 'Default template',
    defaultTemplateDesc: 'Used for direct links shared with customers.',
    posRouteDesc: 'Maps to /template/[alias]/receipt.pdf for POS integration.',
    documentType: 'Document Type',
    invoiceCreditNote: 'Invoice + Credit Note',
    order: 'Order',
    invoiceOnly: 'Invoice only',
    quoteEstimate: 'Quote / Estimate',
    proformaInvoice: 'Proforma Invoice',
    refund: 'Refund',
    stornoInvoice: 'Storno Invoice',
    creditNoteOnly: 'Credit Note only',
    reportLiquid: 'Report (Liquid only)',
    hideRemovedItems: 'Hide removed/refunded line items',
    location: 'Location',
    locationEmpty: 'Leave empty to use for all locations',
    dangerZone: 'Danger Zone',
    dangerZoneDesc: 'Permanently remove this template from your account.',
    removeTemplate: 'Remove template',
    bodyTemplate: 'Body Template',
    bodyTemplateDesc: 'Uses Mustache or Liquid syntax. Click a snippet:',
    rowTemplate: 'Row Template',
    rowTemplateDesc: 'Rendered once per line item. Click a snippet:',
    variableReference: 'Variable Reference',
    formatCode: 'Format Code',
    insert: 'Insert',
    copy: 'Copy',
    loadModelContinue: 'Load Model & Continue',
    cancel: 'Cancel',
    copilotPlaceholder: 'Try: translate to Romanian, show tax columns, add barcode, use teal palette...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Undo',
    redo: 'Redo',
    aiThinking: 'AI is thinking...',
    proposedChanges: 'Proposed Changes',
    applyChanges: 'Apply Changes',
    dismiss: 'Dismiss',
    aiEngineReady: 'AI Engine ready',
    loadingAiModel: 'Loading AI model...',
    aiEngineOff: 'AI Engine off —',
    loadForAdvanced: 'load for advanced edits',
    instantCommands: 'translate, show/hide sections, add snippets, change font/colors/paper',
    aiEngineDesc: 'structural HTML edits, layout changes, custom modifications',
    aiLocalDesc: 'Model runs locally via WebGPU — no data leaves your browser. Larger models are more accurate but use more VRAM.',
    aiUpgradeDesc: 'upgrade to Starter or Professional to unlock advanced AI template editing.',
    upgrade: 'Upgrade',
    loadAiQuestion: 'Load AI Engine?',
    loadAiDesc: 'The on-device AI model will download and run locally using WebGPU. This requires ~1-3 GB of free VRAM/RAM and a modern GPU (M1+ Mac, or discrete GPU on Windows/Linux).',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/tr.js